// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"Loader_lds-dual-ring__NOLU9","loaderContainer":"Loader_loaderContainer__vNzAz"};